import React, { useState, useEffect } from 'react'
import { Button, Drawer, Input, Row, Col, Card, Form, notification, Icon } from 'antd'
import {
  GetDownloadLink,
  InputBox,
  PaymentModes,
  formItemLayout,
  chooseEmailModalFxn
} from '../../../../components/_utils/appUtils'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import { processAbstractPaymentApi } from '../actions'
import { useDispatch } from 'react-redux'
import moment from 'moment'

const AbstractChargesDrawer = (props) => {
  const dispatch = useDispatch()
  let { abstract, onClose, visible, callback, form: { getFieldDecorator, setFieldsValue } } = props
  let [certificateAttachment, setCertificateAttachment] = useState({})

  let { processPayment } = abstract

  let chooseDocument = (e) => {
    let { files } = e.target
    if (files && files.length) {
      setCertificateAttachment(files[0])
    }
  }

  useEffect(() => {
    if (visible) {
      setFormValue()
    }
  }, [visible])

  let setFormValue = () => {
    if (processPayment && processPayment.processingFee) {
      setFieldsValue({
        ...processPayment,
        paymentDate: processPayment.paymentDate ? moment(processPayment.paymentDate) : moment()
      })
    } else {
      setFieldsValue({
        paymentMode: 'Cash',
        paymentType: 'Rs.',
        paymentDate: moment()
      })
    }
  }

  const submitPayment = (e) => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (err) return

      chooseEmailModalFxn({
        callback: async (email) => {
          let obj = {
            processPayment: valData,
            abstractId: abstract._id,
            status: 'Abstract Under Process',
            fromEmail: email,
            template: valData.processingFee > 0 ? 'abstractChargesAcknowledgement' : 'abstractNoChargesAcknowledgement',
            type: 'abstract'
          }
          console.log("DEBUG: Frontend Payload Construction:", JSON.stringify(obj, null, 2));
          let { success, message } = await dispatch(processAbstractPaymentApi(obj))

          if (success) {
            form.resetFields()
            onClose()
            callback()
            notification.success({ message: message })
          }
        }
      })
    })
  }
  let processFields = [
    { label: 'Payment Type', key: 'paymentType', required: true, type: 'select', options: ['Rs.', 'USD'],onChange: (val) => setFieldsValue({ paymentType: val }) },
    { label: 'Process Payment', key: 'processingFee', required: true, type: 'number' },
    { label: 'Payment Mode', key: 'paymentMode', required: true, type: 'select', options: PaymentModes ,onChange: (val) => setFieldsValue({ paymentMode: val })},
    { label: 'Process Payment Date', key: 'paymentDate', required: true, type: 'date' },
  ]

  return (
    <Drawer
      visible={visible}
      title={`Processing Charges | Abstract ID: ${abstract.onlineAbstractId}`}
      width={800}
      onClose={onClose}>
      <Card bordered={true}>
        <Form className={'inputForm'} onSubmit={submitPayment}>
          <Row gutter={16}>
            {processFields.map((item, key) => (
              <Col span={12} key={key}>
                {item.customField ? item.customField :
                  <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator} formItemLayout={formItemLayout} />}
              </Col>
            ))}
            <Col span={24}>
              <Form.Item style={{ marginTop: 32 }}>
                <Button type='primary' htmlType='submit'>SUBMIT</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

export default Form.create()(AbstractChargesDrawer)
